import s from './answer.module.scss'
export default function answer() {
    return (
        <div className={s.container}>
            <p data-aos='fade-up' className={s.text}>So yeah this is the answer of all your questions. 😄</p>
        </div>
    )
}
